import { render, staticRenderFns } from "./statrgyManagerForm.vue?vue&type=template&id=c2d79d4e&scoped=true"
import script from "./statrgyManagerForm.vue?vue&type=script&lang=js"
export * from "./statrgyManagerForm.vue?vue&type=script&lang=js"
import style0 from "./statrgyManagerForm.vue?vue&type=style&index=0&id=c2d79d4e&prod&lang=scss&scoped=true"
import style1 from "./statrgyManagerForm.vue?vue&type=style&index=1&id=c2d79d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d79d4e",
  null
  
)

export default component.exports